// extracted by mini-css-extract-plugin
export default {"auth-input-wrapper":"sendCodeForm_auth-input-wrapper__42oni","auth-input":"sendCodeForm_auth-input__b5Sfl"};